<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="top_filters_area">
            <div class="votes_search">
                <div class="votes_search-top">
                    <div class="text_search_block">
                        <b-form-input
                                v-model="search"
                                placeholder="Search: q's name/plcmnt/asset# | user's name/email"
                                class="search_votes"
                        ></b-form-input>
                        <b-form-input
                                v-model="searchPlace"
                                placeholder="Search by place name/id"
                                class="search_votes"
                        ></b-form-input>
                    </div>
                    <div class="checkbox-filters">
                        <b-form-checkbox v-model="showUserVotes">
                            <span>User's</span>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="showAdminVotes" style="margin-left: 10px;">
                            <span>Admin's</span>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="showServiceLogs" style="margin-left: 10px;">
                            <span>Service logs</span>
                        </b-form-checkbox>
                        <span style="margin-left: 10px; margin-top: 4px; text-decoration: underline; cursor: pointer;" @click="onRefreshVotesClick">Refresh</span>
                        <div class="additional_filters_btn" @click="onExtendedFiltersClick"><span v-if="extendedFiltersShow">Less</span><span v-else>More</span><img v-if="extendedFiltersShow" src="@/assets/icons/chevron-up-solid.svg"><img v-else src="@/assets/icons/chevron-down-solid.svg"></div>
                    </div>
                </div>
                <div class="extended-filters" v-if="extendedFiltersShow">
                    <b-form-checkbox v-model="filterWithSld"><span>sld</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithComments"><span>📝</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithImg"><span>📷</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithGReview"><span>G⭐</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithAudio"><span>🎤</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithContactInfo"><span>👤ℹ️</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithUserGPS"><span>👤📍</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithoutUserGPS"><span><s>👤📍</s></span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithQGPS"><span>Q📍</span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithoutQGPS"><span><s>Q📍</s></span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithoutPlacement"><span><s>plcmnt</s></span></b-form-checkbox>
                    <b-form-checkbox v-model="filterWithoutAssetId"><span><s>asset #</s></span></b-form-checkbox>
                </div>
                <div class="extended-filters" v-if="extendedFiltersShow">
                    <div class="extended-filters-search">
                        <b-form-input
                            v-model="filterQId"
                            placeholder="Q #"
                            class="extended-search"
                            style="max-width: 50px;"
                        ></b-form-input>
                        <b-form-input
                            v-model="filterOrgId"
                            placeholder="O #"
                            class="extended-search"
                            style="max-width: 30px;"
                        ></b-form-input>
                        <b-form-input
                            v-model="filterUserId"
                            placeholder="User #"
                            class="extended-search"
                            style="max-width: 60px;"
                        ></b-form-input>
                        <b-form-input
                            v-model="filterRegUserId"
                            placeholder="Reguser #"
                            class="extended-search"
                            style="max-width: 65px;"
                        ></b-form-input>
                        <b-form-input
                            v-model="filterComment"
                            placeholder="Search comments"
                            class="extended-search"
                        ></b-form-input>
                        <b-form-input
                            v-model="filterRateId"
                            placeholder="R ###"
                            class="extended-search"
                            style="max-width: 130px;"
                        ></b-form-input>
                        <b-form-checkbox v-model="analysisNotEmptyOnly" style="margin-left: 10px;">
                            <span>ANE</span>
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <b-list-group class="votes_list" @scroll="onListScrolled">
            <b-list-group-item v-for="(item, index) in votes" :key="index" class="votes_item"
                    :class="{selected: item.selected}">
                <div class="control-panel">
                    <div @click="DeleteVoteClick(item)" class="control-panel-item">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                </div>

                <div class="votes_top">
                    <div class="votes_body">
                        <div class="wrapper" >
                            <input type="checkbox" v-model="item.selected" class="rate-cb" @change="onVoteSelectChanged(item)">
                            <div v-html="getVoteEmoji(item.rate)"></div>
                            <h5> {{item.place.name}} ({{item.id}})</h5>
                            <img class="gps_icon" :src="getGpsIcon(item)" v-if="getGpsIcon(item)">
                        </div>
                        <div>
                            <h5 v-if="item.google_review"><a :href="item.google_review.review_data.review_link" target="_blank">Google {{ item.google_review.review_data.review_rating }}⭐  review</a></h5>
                        </div>
                        <h5>{{item.question ? item.question.text : ''}}</h5>
                        <span><a :href="getQuestionManageLink(item)" target="_blank"><span v-if="item.question && item.question.asset_id != ''">{{item.question ? item.question.asset_id : ''}} | </span>{{item.placement}}</a><a v-if="item.rate_location" :href="getGeolocationGoogleMapLink(item)" target="_blank"> ({{item.rate_location.lat}}, {{item.rate_location.lng}})</a></span>
                        <p>
                            <i>{{item.date_create | moment("HH:mm:ss D.MM.YYYY ")}}</i>
                            <span>#{{item.question ? item.question.id : ''}}</span>
                        </p>
                        <div class="votes_customer" v-if="item.registered_user == null">
                            <h5>User #{{item.user.id}} ({{item.prior_votes_by_place}})</h5>
                        </div>
                        <div class="votes_customer" v-if="item.registered_user != null">
                            <h5>{{item.registered_user.first_name }} {{item.registered_user.last_name }} {{item.registered_user.email}} ({{item.prior_votes_by_place}})</h5>
                        </div>
                    </div>
                </div>
                <div class="votes_bottom">
                    <div class="votes_place">
                        <span class="votes_comment" v-if="!standardAnswersCheck(item.answer)"><b>Answer:</b> {{item.answer}} </span>
                        <span class="votes_comment" v-if="item.comment != '' || item.sec_level.length > 0"><b>Comment:</b> {{item.comment}} <u v-if="item.sec_level.length > 0">| {{item.sec_level.join(', ')}}</u></span>
                        <span class="votes_comment" v-if="item.contact_info != ''"><b>Contact info:</b> {{item.contact_info}}</span>
                        <span class="votes_comment groups" v-if="item.ra_groups.length > 0"><div v-for="(group, index) in item.ra_groups" class="ra_group">{{group.title}}</div></span>
                        <div v-if="item.attachments.audio"><audio controls :src="item.attachments.audio.audio_url" class="vote-audio"></audio></div>
                        <div class="attachments" v-if="item.attachments.images.length > 0">
                            <div v-for="(image, index) in item.attachments.images"
                                 :key="index" style="position: relative"
                                class="attachment-img-wrapper">
                                <img :src="image.previewUrl"
                                     @click="onVoteImageClick(image)"/>
                                <div class="delete_cross" @click="DeleteVoteImageClick(item, image)">
                                    <img src="@/assets/icons/ic_trash.svg" alt="">
                                </div>
                                <div class="img-info">
                                    <div class="img-removed-by-ai" v-if="image.is_hidden">Removed by AI</div>
                                    <div class="img-tags" v-if="image.tags">{{ image.tags.join(', ') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="rate-btns">
                            <div class="analysis-btn"
                                 @click="item.showDetails = !item.showDetails"
                            >Logs</div>
                            <div class="analysis-btn"
                                 @click="item.showActions = !item.showActions"
                            >Actions</div>
                            <div class="analysis-btn"
                                 @click="item.showAnalysis = !item.showAnalysis"
                                 v-if="(item.analysis && Object.keys(item.analysis).length > 0)"
                            >Analysis</div>
                        </div>
                    </div>
                </div>
                <div class="rate_logs" v-if="item.showDetails">
                    Logs:
                    <table>
                        <tr>
                            <td class="log_action">Vote created</td>
                            <td>{{ item.date_create | moment("HH:mm:ss:SSS D.MM.YYYY ") }}</td>
                        </tr>
                        <tr v-for="(log) in item.gps_logs">
                            <td class="log_action">{{ log.action }}</td>
                            <td>{{ log.device_date_utc | moment("HH:mm:ss:SSS D.MM.YYYY ") }}</td>
                        </tr>
                    </table>
                </div>
                <div class="rate_logs" v-if="item.showAnalysis && (item.analysis && Object.keys(item.analysis).length > 0)">
                    Analysis:
                    <table>
                        <tr v-for="(key) in Object.keys(item.analysis)" v-if="showAnalysisItem(item, key)">
                            <td class="log_action">{{ key }}</td>
                            <td>{{ item.analysis[key] }}</td>
                        </tr>
                    </table>
                </div>
                <div class="rate_logs" v-if="item.showActions" >
                    <div>
                        <div class="action"
                             v-if="item.attachments.images.length > 0"
                             @click="onCopyImagesToClick(item)"
                        >Copy images to vote</div>
                        <div class="action"
                             @click="onEditVoteCommentClick(item)"
                        >{{ item.comment != '' ? 'Edit comment' : 'Add comment' }}</div>
                        <div class="action"
                             v-if="item.attachments.images.length > 0
                             || item.attachments.audio
                             || item.sec_level.length > 0
                             || item.comment != ''"
                             @click="onTransferDataToVoteClick(item)"
                        >Transfer data to vote</div>
                        <div class="action" @click="onDuplicateVoteClick(item)">Duplicate vote</div>
                    </div>
                </div>
            </b-list-group-item>

            <infinite-loading :identifier="infinityValue" @infinite="getVotes">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>

        <div class="votes-actions-f-menu-btn" v-if="bulkActionsMenu.showToggle"
            @click="bulkActionsMenu.show = !bulkActionsMenu.show">{{ (bulkActionsMenu.show ? 'Close' : 'Actions') + ` (${bulkActionsMenu.votesSelected})` }}</div>
        <div class="votes-actions-f-menu" v-if="bulkActionsMenu.show">
<!--            <div class="vaf-item" @click="onBulkAssignToPlaceClick()">Assign to place</div>-->
            <div class="vaf-item" @click="onBulkAssignToQuestionClick()">Assign to question</div>
            <div class="vaf-item" @click="onBulkRemoveVotesClick()">Remove</div>
            <div class="vaf-item" @click="onClearVotesSelectionClick()">Clear selection</div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from "@/mixins/errorMixin";
import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
import adminPageMixin from "@/mixins/adminPageMixin";

export default {
        mixins: [mixin, errorMixin, adminStickyHeaderMixin, adminPageMixin,],
        name: "Votes",
        components: {
            InfiniteLoading,
            customModalDialog
        },
        data() {
            return {
                search: '',
                searchPlace: '',
                filterWithSld: false,
                filterWithComments: false,
                filterWithImg: false,
                filterWithGReview: false,
                filterWithAudio: false,
                filterWithUserGPS: false,
                filterWithoutUserGPS: false,
                filterWithQGPS: false,
                filterWithoutQGPS: false,
                filterWithContactInfo: false,
                filterWithoutPlacement: false,
                filterWithoutAssetId: false,
                filterQId: '',
                filterOrgId: '',
                filterUserId: '',
                filterRegUserId: '',
                filterComment: '',
                filterRateId: '',
                extendedFiltersShow: localStorage.getItem('adminExtendedFiltersShow') == 'true',
                showUserVotes: localStorage.getItem('adminShowVotes') || true,
                showAdminVotes: localStorage.getItem('adminShowAdminVotes') || false,
                showServiceLogs: localStorage.getItem('adminShowServiceLogs') || true,
                analysisNotEmptyOnly: false,
                customModalSettings: {},
                votes: [],
                infinityValue: +new Date(),
                page: 1,
                searchTimer: null,
                standardAnswers: new Set (['happy', 'so-so', 'sad', 'плохо', 'так себе', 'супер', 'погано', 'так собі', 'sehr gut', 'genügend', 'schlecht']),
                bulkActionsMenu: {
                    showToggle: false,
                    show: false,
                    votesSelected: 0,
                },
            }
        },
        props: ['infinity'],
        watch: {
            showUserVotes(newValue) {
                this.resetList()
                localStorage.setItem('adminShowVotes', newValue)
            },
            showAdminVotes(newValue) {
                this.resetList()
                localStorage.setItem('adminShowAdminVotes', newValue)
            },
            showServiceLogs(newValue) {
                this.resetList()
                localStorage.setItem('adminShowServiceLogs', newValue)
            },
            search(value) {
                this.refreshVotes()
            },
            searchPlace(value) {
                this.refreshVotes()
            },
            filterWithSld(value) {
                this.refreshVotes()
            },
            filterWithComments(value) {
                this.refreshVotes()
            },
            filterWithImg(value) {
                this.refreshVotes()
            },
            filterWithGReview(value) {
                this.refreshVotes()
            },
            filterWithAudio(value) {
                this.refreshVotes()
            },
            filterWithUserGPS(value) {
                if(value && this.filterWithoutUserGPS) this.filterWithoutUserGPS = false
                this.refreshVotes()
            },
            filterWithoutUserGPS(value) {
                if(value && this.filterWithUserGPS) this.filterWithUserGPS = false
                this.refreshVotes()
            },
            filterWithQGPS(value) {
                if(value && this.filterWithoutQGPS) this.filterWithoutQGPS = false
                this.refreshVotes()
            },
            filterWithoutQGPS(value) {
                if(value && this.filterWithQGPS) this.filterWithQGPS = false
                this.refreshVotes()
            },
            filterWithContactInfo(value) {
                this.refreshVotes()
            },
            filterWithoutPlacement(value) {
                this.refreshVotes()
            },
            filterWithoutAssetId(value) {
                this.refreshVotes()
            },
            filterQId(value) {
                this.refreshVotes()
            },
            filterOrgId(value) {
                this.refreshVotes()
            },
            filterUserId(value) {
                this.refreshVotes()
            },
            filterRegUserId(value) {
                this.refreshVotes()
            },
            filterComment(value) {
                this.refreshVotes()
            },
            filterRateId(value) {
                this.refreshVotes()
            },
            infinity(val) {
                this.page = 1
                this.infinityValue += 1
            },
        },
    mounted() {
        this.initAdminPage()
    },
        methods: {
            ...mapActions({
                fetchVotesAction: 'question/fetchVotes',
                deleteVote: 'profiles/deleteVote',
                deleteVoteImage: 'profiles/deleteVoteImage',
                copyVoteImagesTo: 'rate/copyVoteImagesTo',
                editVoteComment: 'rate/editVoteComment',
                transferVoteDataTo: 'rate/transferVoteDataTo',
                duplicateVote: 'rate/duplicateVote',
                deleteVotes: 'rate/deleteVotes',
                changeVotesPlace: 'rate/changeVotesPlace',
                changeVotesQuestion: 'rate/changeVotesQuestion',
            }),
            resetList() {
                this.page = 1;
                this.votesLoaded = false
                this.votes = [];
                this.infinityValue += 1;
            },
            onRefreshVotesClick() {
                this.resetList()
            },
            async getVotes(stateInf) {
                try {
                    this.loadingAction = true
                    const response = await this.fetchVotesAction({
                        page: this.page,
                        s: encodeURIComponent(this.search),
                        votes: this.showUserVotes,
                        admin_votes: this.showAdminVotes,
                        sl: this.showServiceLogs,
                        place: encodeURIComponent(this.searchPlace),
                        with_sld: this.filterWithSld,
                        with_comments: this.filterWithComments,
                        with_img: this.filterWithImg,
                        g_review: this.filterWithGReview,
                        with_audio: this.filterWithAudio,
                        with_user_gps: this.filterWithUserGPS,
                        without_user_gps: this.filterWithoutUserGPS,
                        with_question_gps: this.filterWithQGPS,
                        without_question_gps: this.filterWithoutQGPS,
                        with_contact_info: this.filterWithContactInfo,
                        with_empty_plcmnt: this.filterWithoutPlacement,
                        with_empty_asset_id: this.filterWithoutAssetId,
                        q_id: this.filterQId,
                        org_id: this.filterOrgId,
                        user_id: this.filterUserId,
                        reg_user_id: this.filterRegUserId,
                        comment: encodeURIComponent(this.filterComment),
                        rate_id: encodeURIComponent(this.filterRateId),
                    })
                    if (response.success) {
                        this.page += 1;
                        if (this.votes.length == 0) {
                            for(let i = 0; response.rates.length > i; i++) {
                                response.rates[i].showDetails = false
                                response.rates[i].showAnalysis = false
                                response.rates[i].showActions = false
                                response.rates[i].selected = false
                            }
                            this.votes = response.rates;
                        } else {
                            response.rates.forEach((item) => {
                                item.showDetails = false
                                item.showAnalysis = false
                                item.showActions = false
                                item.selected = false
                                this.votes.push(item);
                                console.log(item)
                            })
                        }
                        if (stateInf && stateInf.loaded != undefined) {
                            if (response.rates.length === 10) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal()
                } finally {
                    this.loadingAction = false
                }
            },

            DeleteVoteClick(vote) {
                this.customModalSettings = {
                    message: this.translate('admin_deleteVote', [vote.question ? vote.question.text : '']),
                    onOkHandler: this.deleteVoteAction.bind(null, vote),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            async deleteVoteAction(vote) {
                try {
                    await this.deleteVote(vote)
                    const index = this.votes.findIndex(item => item === vote)
                    this.votes.splice(index, 1)

                    this.customModalSettings = {
                        message: this.translate('admin_successMessageRemoveVote'),
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            DeleteVoteImageClick(vote, image) {
                this.customModalSettings = {
                    message: this.translate('admin_delete_image'),
                    onOkHandler: this.deleteVoteImageAction.bind(null, image.uid, vote),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },
            async deleteVoteImageAction(imageGuid, vote) {
                const body = {
                    vote_guid: vote.uid,
                    image_guid: imageGuid
                }
                try {
                    await this.deleteVoteImage(body)
                    const index = vote.attachments.images.findIndex(element => element.uid == imageGuid)
                    vote.attachments.images.splice(index, 1)
                    this.customModalSettings = {
                        message: this.translate('admin_successImageDelete'),
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            refreshVotes() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                }
                this.searchTimer = setTimeout(() => {
                    this.page = 1;
                    this.votes = [];
                    this.infinityValue += 1;
                }, 450);
            },

            onVoteImageClick(item) {
                window.open(item.originUrl, '_blank')
            },

            getGeolocationGoogleMapLink(vote) {
                return `https://www.google.com/maps/place/${vote.rate_location.lat},${vote.rate_location.lng}/@${vote.rate_location.lat},${vote.rate_location.lng},17z`
            },

            getQuestionManageLink(vote) {
                return `${location.origin}/questions/${vote.question ? vote.question.uid : ''}/manage`
            },
            standardAnswersCheck(item) {
              return item == null ? false : this.standardAnswers.has(item.toLowerCase())
            },
            getVoteEmoji(item) {
                switch (item) {
                    case 3 : {
                        return `<div style='width: 15px; height: 15px; background: #008000; border: 1px solid black'></div>`
                    }
                    case 2 : {
                        return `<div style='width: 15px; height: 15px; background: #FFFF00; border: 1px solid black'></div>`
                    }
                    case 1 : {
                        return `<div style='width: 15px; height: 15px; background: #FF0000; border: 1px solid black'></div>`
                    }
                }
            },
            voteHasLogs(vote) {
                return vote.gps_logs && vote.gps_logs.length > 0
            },
            getGpsIcon(vote) {
                if(!this.voteHasLogs(vote)) return null

                let receivedGps = vote.gps_logs.find(value => value.action == 'gps_received') != null
                let blockedGps = vote.gps_logs.find(value => value.action == 'gps_declined_popup' || value.action == 'gps_disallowed') != null
                let hasGpsLog = vote.gps_logs.find(value => value.action.includes('gps_')) != null

                if(receivedGps) {
                    return require('@/assets/icons/ic_gps_reveived.svg')
                } else if(blockedGps) {
                    return require('@/assets/icons/ic_gps_blocked.svg')
                } else if(hasGpsLog) {
                    return require('@/assets/icons/ic_gps_broblem.svg')
                } else {
                    return null
                }
            },
            onListScrolled(element) {
                this.fixStickyHeader(element.srcElement.scrollTop)
            },
            onExtendedFiltersClick() {
                this.extendedFiltersShow = !this.extendedFiltersShow
                localStorage.setItem('adminExtendedFiltersShow', this.extendedFiltersShow ? 'true' : 'false')
            },
            showAnalysisItem(vote, key) {
                let value = vote.analysis[key]
                return this.analysisNotEmptyOnly == false
                    || (
                        (Array.isArray(value) && value.length > 0)
                        || (typeof value == "boolean" && value != false)
                    )
            },
            onCopyImagesToClick(vote) {
                this.customModalSettings = {
                    vote: vote,
                    message: 'Copy images to the vote',
                    input: {
                        label: 'Enter target vote ID',
                        placeholder: 'ID',
                        value: '',
                        type: 'number',
                    },
                    onOkHandler: this.onCopyImagesTargetVoteEntered,
                    showCancelButton: true,
                    okButtonText: 'Copy',
                    cancelButtonText: 'Cancel',
                }
            },
            async onCopyImagesTargetVoteEntered(settings) {
                let vote = settings.vote
                let targetVoteId = settings.input.value
                try {
                    await this.copyVoteImagesTo({
                        source_vote_id: vote.id,
                        target_vote_id: targetVoteId
                    })
                    this.setMessageModel({
                        msg: 'Images copied.',
                        duration: 1000,
                    })
                } catch (error) {
                    console.log('error copyVoteImagesTo', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            onEditVoteCommentClick(vote) {
                this.customModalSettings = {
                    vote: vote,
                    message: (vote.comment != '' ? 'Edit comment' : 'Add comment'),
                    input: {
                        label: 'Comment',
                        placeholder: 'comment',
                        value: vote.comment,
                        type: 'text',
                    },
                    onOkHandler: this.onAddEditCommentEntered,
                    showCancelButton: true,
                    okButtonText: 'Copy',
                    cancelButtonText: 'Cancel',
                }
            },
            async onAddEditCommentEntered(settings) {
                let vote = settings.vote
                let comment = settings.input.value
                try {
                    await this.editVoteComment({
                        vote_id: vote.id,
                        comment: comment
                    })
                    this.setMessageModel({
                        msg: 'Comment changed.',
                        duration: 1000,
                    })
                    vote.comment = comment
                } catch (error) {
                    console.log('error editVoteComment', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            onTransferDataToVoteClick(vote) {
                let checkboxes = []
                if(vote.comment != '') {
                    checkboxes.push({
                        checked: false,
                        id: 'comment',
                        title: 'Replace comment'
                    })
                }
                if(vote.sec_level.length > 0) {
                    checkboxes.push({
                        checked: false,
                        id: 'sec_level',
                        title: 'Replace second level details'
                    })
                }
                if(vote.attachments.images.length > 0) {
                    checkboxes.push({
                        checked: false,
                        id: 'images',
                        title: 'Copy images'
                    })
                }
                if(vote.attachments.audio) {
                    checkboxes.push({
                        checked: false,
                        id: 'audio',
                        title: 'Replace audio'
                    })
                }
                checkboxes.push({
                    checked: false,
                    id: 'remove_source_vote',
                    title: 'Remove source vote (!!!)'
                })
                this.customModalSettings = {
                    vote: vote,
                    message: 'Transfer data to the vote.\nAll data except images will replace the existing data of the target vote',
                    input: {
                        label: 'Enter target vote ID',
                        placeholder: 'ID',
                        value: '',
                        type: 'number',
                    },
                    checkboxes: checkboxes,
                    onOkHandler: this.onTransferDataToTheVoteEntered,
                    showCancelButton: true,
                    okButtonText: 'Copy',
                    cancelButtonText: 'Cancel',
                }
            },
            async onTransferDataToTheVoteEntered(settings) {
                let vote = settings.vote
                let targetVoteId = settings.input.value
                try {
                    let data = {
                        source_vote_id: vote.id,
                        target_vote_id: targetVoteId
                    }
                    settings.checkboxes.forEach(checkbox => {
                        console.log(`checkbox:`, checkbox)
                        if (checkbox.id == 'comment') {
                            data['copy_comment'] = checkbox.checked
                        }
                        if (checkbox.id == 'sec_level') {
                            data['copy_sec_level'] = checkbox.checked
                        }
                        if (checkbox.id == 'images') {
                            data['copy_images'] = checkbox.checked
                        }
                        if (checkbox.id == 'audio') {
                            data['copy_audio'] = checkbox.checked
                        }
                        if (checkbox.id == 'remove_source_vote') {
                            data['remove_source_vote'] = checkbox.checked
                        }
                    })
                    await this.transferVoteDataTo(data)
                    this.setMessageModel({
                        msg: 'Vote data transfer completed.',
                        duration: 1000,
                    })
                } catch (error) {
                    console.log('error transferVoteDataTo', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            onDuplicateVoteClick(vote) {
                let checkboxes = []
                checkboxes.push({
                    checked: true,
                    id: 'take_target_q_placement',
                    title: 'Take placement from target question'
                })
                checkboxes.push({
                    checked: true,
                    id: 'take_target_q_gps',
                    title: 'Take Rate GPS from target question'
                })
                this.customModalSettings = {
                    vote: vote,
                    message: 'Duplicate vote',
                    input: {
                        label: 'Enter target question ID',
                        placeholder: 'Question ID',
                        value: vote.question.id,
                        type: 'number',
                    },
                    additionalInputs: [
                        {
                            label: 'Time diff in minutes (can be negative)',
                            value: 0,
                            type: 'number',
                        },
                    ],
                    checkboxes: checkboxes,
                    onOkHandler: this.onDuplicateVoteEntered,
                    showCancelButton: true,
                    okButtonText: 'Copy',
                    cancelButtonText: 'Cancel',
                }
            },
            async onDuplicateVoteEntered(settings) {
                let vote = settings.vote
                let targetQId = settings.input.value
                let timeDiff = settings.additionalInputs[0].value
                try {
                    let data = {
                        source_vote_id: vote.id,
                        target_question_id: targetQId,
                        mins_diff: timeDiff,
                    }
                    settings.checkboxes.forEach(checkbox => {
                        if (checkbox.id == 'take_target_q_placement') {
                            data['take_target_q_placement'] = checkbox.checked
                        }
                        if (checkbox.id == 'take_target_q_gps') {
                            data['take_target_q_gps'] = checkbox.checked
                        }
                    })
                    const response = await this.duplicateVote(data)
                    this.setMessageModel({
                        msg: `Vote duplicated: ${response.data.id}`,
                        duration: 1000,
                    })
                } catch (error) {
                    console.log('error duplicateVote', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            onVoteSelectChanged(item) {
                let selectedCount = this.votes.filter(item=> item.selected).length
                this.bulkActionsMenu.votesSelected = selectedCount
                this.handleVoteSelectChanged()
            },
            handleVoteSelectChanged() {
                let isLargeScreen = window.innerWidth > 700
                let selectedCount = this.bulkActionsMenu.votesSelected
                if(selectedCount > 0) {
                    this.bulkActionsMenu.showToggle = true
                    this.bulkActionsMenu.show = (selectedCount == 1 && isLargeScreen) || (selectedCount > 1 && this.bulkActionsMenu.show)
                } else {
                    this.bulkActionsMenu.show = false
                    this.bulkActionsMenu.showToggle = false
                }
            },
            onBulkRemoveVotesClick() {
                this.customModalSettings = {
                    message: `Please confirm you want to remove ${this.bulkActionsMenu.votesSelected} votes`,
                    onOkHandler: this.onConfirmRemoveBulkVotesClick,
                    showCancelButton: true,
                    okButtonText: 'Remove',
                    cancelButtonText: 'Cancel',
                }
            },
            async onConfirmRemoveBulkVotesClick() {
                let ids = this.votes.filter(item => item.selected).map(item => item.id)
                console.log(`delete votes:`, ids);
                try {
                    await this.deleteVotes({
                        ids: ids,
                    })
                    this.setMessageModel({
                        msg: 'Votes removed.',
                        duration: 1000,
                    })
                    this.clearVotesSelection()
                    this.refreshVotes()
                } catch (error) {
                    console.log('error deleteVotes', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            onBulkAssignToPlaceClick() {
                this.customModalSettings = {
                    message: 'Change votes place',
                    input: {
                        label: 'Place id',
                        placeholder: 'Place id',
                        value: '',
                        type: 'number',
                    },
                    onOkHandler: this.onConfirmChangeVotesPlaceClick,
                    showCancelButton: true,
                    okButtonText: 'Change',
                    cancelButtonText: 'Cancel',
                }
            },
            async onConfirmChangeVotesPlaceClick(settings) {
                let ids = this.votes.filter(item => item.selected).map(item => item.id)
                console.log(`change votes place:`, ids);
                try {
                    await this.changeVotesPlace({
                        ids: ids,
                        place_id: settings.input.value,
                    })
                    this.setMessageModel({
                        msg: 'Place changed.',
                        duration: 1000,
                    })
                    this.refreshVotes()
                } catch (error) {
                    console.log('error changeVotesPlace', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },

            onBulkAssignToQuestionClick() {
                this.customModalSettings = {
                    message: 'Change votes question',
                    input: {
                        label: 'Question id',
                        placeholder: 'Question id',
                        value: '',
                        type: 'number',
                    },
                    onOkHandler: this.onConfirmChangeVotesQuestionClick,
                    showCancelButton: true,
                    okButtonText: 'Change',
                    cancelButtonText: 'Cancel',
                }
            },
            async onConfirmChangeVotesQuestionClick(settings) {
                let ids = this.votes.filter(item => item.selected).map(item => item.id)
                console.log(`change votes question:`, ids);
                try {
                    await this.changeVotesQuestion({
                        ids: ids,
                        question_id: settings.input.value,
                    })
                    this.setMessageModel({
                        msg: 'Question changed.',
                        duration: 1000,
                    })
                    this.refreshVotes()
                } catch (error) {
                    console.log('error changeVotesQuestion', error)
                    this.showErrorModal(e.data.error.message, {title: 'Something went wrong'})
                }
            },
            clearVotesSelection() {
                this.votes.forEach(item => {
                    item.selected = false
                })
                this.bulkActionsMenu.votesSelected = 0
            },
            onClearVotesSelectionClick() {
                this.clearVotesSelection()
                this.handleVoteSelectChanged()
            },
        }
    }
</script>

<style scoped>
    .votes_list {
        max-height: calc(100vh - 62px);
    }
    .votes_list {
        overflow: auto;
        margin-bottom: 0;
        width: 100%;
        min-width: 100%;
    }

    .votes_item {
        display: table;
        width: 100%;
        min-width: 100%;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        font-size: .75em

    }

    .votes_item.selected {
        background: #fff6db;
    }

    .votes_top {
        display: flex;
        width: 100%;
        padding: .5em 1em 0;
    }

    .votes_bottom {
        width: 100%;
        flex-direction: row;
        display: flex;
        padding: 0 1em;
    }

    .rate_logs table {
        width: fit-content;
    }
    .rate_logs tr {
        border-top: 1px solid #e1e1e1;
    }
    .rate_logs .log_action {
        min-width: 130px;
        font-weight: 800;
    }
    .rate_logs {
        width: 100%;
        flex-direction: column;
        display: flex;
        padding: 0 1em;
        border-top: 1px solid #e7e7e7;
    }
    .rate_logs .action {
        height: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .rate_logs .action:hover {
        background: #f6f6f6;
    }

    .rate-btns {
        margin-top: 4px;
        display: flex;
        flex-direction: row;
        gap: 8px;
    }

    .analysis-btn {
        border: 1px solid black;
        width: 66px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        align-items: center;
        height: 26px;
    }

    .analysis-btn:hover {
        background-color: rgba(48, 128, 26, 0.33);
    }

    .votes_comment {
        font-weight: 500;
    }

    .votes_comment.groups {
        display: flex;
        flex-direction: row;
        gap: 4px;
        padding-bottom: 2px;
        padding-top: 2px;
        flex-wrap: wrap;
    }

    .ra_group {
        background: rgb(185 105 0);
        border-radius: 10px;
        padding-left: 8px;
        padding-right: 8px;
        color: white;
        height: 18px;
        line-height: 18px;
        font-weight: 700;
    }

    .attachments {
        height: 170px;
        overflow: hidden;
        display: flex;
    }
    .attachment-img-wrapper:not(:first-child) {
        border-left: 1px solid white;
    }
    .attachments img {
        max-width: 100%;
        max-height: 170px;
        cursor: pointer;
    }
    .delete_cross img {
        margin-top: 5px;
        position: absolute;
        top: 0;
        right: 5px;
        z-index: 99;
        background-color: rgba(0, 0, 0, 0.5);;
        border-radius: 6px;
    }
    .img-info {
        position: absolute;
        z-index: 99;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .img-removed-by-ai {
        color: rgba(255, 255, 255, 1);
        background: rgba(191, 0, 0, 0.63);
        display: flex;
        justify-content: center;
    }
    .img-tags {
        color: rgba(255, 255, 255, 1);
        background: rgba(0, 191, 10, 0.63);
        display: flex;
        justify-content: center;
        /*font-size: 14px;*/
        padding-left: 6px;
        padding-right: 6px;
        word-break: break-all;
        line-height: 12px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .votes_bottom > div {
        width: 100%;
        padding-top: .25em;
        padding-bottom: .25em;
    }

    .votes_bottom h5 {
        font-weight: 700;
        font-size: 1em;
        margin-bottom: .2em;
    }

    .votes_bottom span {
        display: block;
    }

    .votes_bottom .votes_place {
        padding-right: 1em;
        position: relative;
    }

    .votes_bottom .votes_place:before {
        position: absolute;
        content: '';
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        background-color: rgba(0, 0, 0, 0.075);
    }

    .votes_bottom .votes_customer {
        padding-left: 1em;
    }

    .votes_img img {
        width: 3.5em;
        height: 3.5em;
        transform: scale(1);
        margin: 0;
    }
    .gps_icon {
        width: auto;
        height: 17px;
    }

    .votes_body {
        display: flex;
        flex-direction: column;
        width: calc(100% - 5em);
    }

    .votes_body h5 {
        font-weight: 700;
        font-size: 1em;
        margin-bottom: .2em;
    }

    .votes_body p {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0;
    }
    .votes_body a {
        color: black;
        cursor: pointer;
        text-decoration: underline;
    }
    .vote-audio {
        margin-top: 8px;
        height: 25px;
        width: 100%;
        max-width: 400px;
        display: block;
    }
    .rate-cb {
        margin-right: 4px;
        cursor: pointer;
    }
    #square {
        width: 120px;
        height: 120px;
        background: #f447ff;
    }
    .wrapper {
        display: flex;
    }
    .wrapper h5 {
        margin-left: 5px;
    }
    .search_votes {
        width: 350px;
        margin-bottom: 7px;
        margin-left: 12px;
    }
    .votes_search-top {
        display: flex;
        flex-direction: row;
    }
    .votes_search {
        display: flex;
        flex-direction: column;
    }
    .text_search_block {
        display: flex;
        flex-direction: row;
    }
    .additional_filters_btn {
        flex-direction: row;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
    }
    .additional_filters_btn img {
        max-width: 16px;
        width: 16px;
        margin-left: 3px;
    }
    .checkbox-filters {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 12px;
        line-height: 12px;
    }
    .extended-filters {
        padding-top: 0px;
        padding-bottom: 4px;
        display: flex;
        margin-left: 5px;
        flex-wrap: wrap;
    }
    .extended-filters .custom-control {
        margin-left: 7px;
    }
    .extended-filters span {
        margin-left: 2px;
    }
    .extended-filters-search {
        display: flex;
        flex-direction: row;
        margin-left: 2px;
    }
    .extended-search {
        width: calc(100% - 24px);
        margin-left: 6px;
        margin-right: 6px;
        max-height: 32px;
        padding: 0;
    }
    .votes-actions-f-menu-btn {
        display: flex;
        position: fixed;
        bottom: 12px;
        right: 12px;
        z-index: 999999;
        align-items: center;
        height: 40px;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 20px;
        cursor: pointer;
        background: #4a4a4a;
        color: white;
        border: 1px solid #4a4a4a;
    }
    .votes-actions-f-menu-btn:hover {
        background: #d2d2d2;
        color: #2b2b2b;
    }
    .votes-actions-f-menu {
        display: flex;
        flex-direction: column;
        position: fixed;
        bottom: 60px;
        right: 12px;
        border-radius: 8px;
        background: #4a4a4a;
        z-index: 999999;
        min-width: 140px;
        color: white;
    }
    .vaf-item {
        height: 36px;
        display: flex;
        align-items: center;
        padding-left: 12px;
        padding-right: 12px;
        cursor: pointer;
    }
    .vaf-item:hover {
        background: #d2d2d2;
        color: #2b2b2b;
    }
    @media screen and (max-width: 1024px) {
        .votes_search-top {
            display: flex;
            flex-direction: column;
            padding-bottom: 12px;
        }
        .search_votes {
            width: calc(100% - 24px);
            margin-right: 12px;
        }
    }
    @media screen and (max-width: 600px) {
        .search_votes {
            width: calc(100% - 12px);
            margin-right: 6px;
            margin-left: 6px;
        }
        .checkbox-filters {
            margin-left: 6px;
            font-size: 12px;
            line-height: 12px;
        }
        .extended-filters {
            margin-left: 0;
        }
    }
</style>
<style>
.admin_main_wrapper {
    position: relative;
}
.top_filters_area {
    display: flex;
    flex-direction: column;
    background: white;
    border-bottom: 1px solid #737373;
    padding-left: 2px;
    padding-right: 2px;
}
.top_filters_area.sticky {
    position: absolute;
    z-index: 998;
    left: 0;
    right: 0;
}
</style>
